import React from 'react';
import { classes } from '../Components/GenericTable/styles';
import { SxProps } from '@mui/material';
import { candidatesTableColumn } from '../Candidates/config';
import { ActionListItem } from '../Components/GenericTable/GenericTableActions';
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  FileCopy as FileCopyIcon
} from '@mui/icons-material';
import { ITableColumns } from './types';

export enum ModalType {
  NEW_QUESTION = 'new question',
  NEW_TAG = 'new tag',
  MERGE_TAGS = 'merge tags',
  BULK_DELETE_TAGS = 'bulk delete tags',
  NEW_JOB_TEMPLATE = 'new job template'
}

export const BASE_URL = window.location.origin;

export const fieldTypeOptions = [
  'Select',
  'Date',
  'Text',
  'Radio Button',
  'Rank',
  'Checkbox',
  'Textarea'
];

export const fieldTypeValues = {
  Select: 'select_field',
  Date: 'date_field',
  Text: 'text_field',
  'Radio Button': 'radio_button_field',
  Rank: 'rank_field',
  Checkbox: 'check_box_field',
  Textarea: 'text_area_field'
};

export const questionsTableColumn: ITableColumns = [
  {
    id: 'name',
    label: 'Name',
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: 'type',
    label: 'Type',
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: 'created_by',
    label: 'Created By',
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: 'updated_by',
    label: 'Last Edited By',
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: 'created_at',
    label: 'Created At',
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: 'updated_at',
    label: 'Updated At',
    sortable: true,
    canToggle: false,
    enabled: true
  }
];

export const jobTemplatesTableColumn: ITableColumns = [
  {
    id: 'name',
    label: 'Name',
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: 'created_by',
    label: 'Created By',
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: 'updated_by',
    label: 'Last Edited By',
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: 'created_at',
    label: 'Created At',
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: 'updated_at',
    label: 'Updated At',
    sortable: true,
    canToggle: false,
    enabled: true
  }
];

export const tagsTableColumn: ITableColumns = [
  {
    id: 'name',
    label: 'Name',
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: 'created_by',
    label: 'Created By',
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: 'updated_by',
    label: 'Last Edited By',
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: 'created_at',
    label: 'Created At',
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: 'updated_at',
    label: 'Updated At',
    sortable: true,
    canToggle: false,
    enabled: true
  },
  {
    id: 'candidates_count',
    label: 'Candidates Count',
    sortable: true,
    canToggle: false,
    enabled: true
  }
];

export const headerStyle = (
  name: (typeof candidatesTableColumn)[number]['id'] | 'checkbox' | 'actions',
  tableHovered: boolean
): SxProps => {
  switch (name) {
    case 'name':
      return { ...classes.sticky, maxWidth: '150px', minWidth: '150px' };
    case 'type':
      return {
        ...classes.sticky,
        ...classes.itemTitleTableCell,
        ...(tableHovered && classes.scrollShadowVisible),
        left: '150px',
        minWidth: '100px'
      };
    case 'created_by':
      return { minWidth: '125px' };
    case 'updated_by':
      return { minWidth: '150px' };
    case 'created_at':
      return { minWidth: '150px' };
    case 'updated_at':
      return { minWidth: '150px' };
    case 'actions':
      return {
        ...classes.actionsColumnHeader,
        ...(tableHovered && classes.scrollShadowVisible)
      };
    default:
      return { minWidth: '90px' };
  }
};

export const candidatesActionsListItem: ActionListItem[] = [
  {
    id: 'edit',
    tooltipLabel: 'Edit',
    icon: <EditIcon />,
    elementId: 'edit-question-library-button'
  },
  {
    id: 'clone',
    tooltipLabel: 'Clone',
    icon: <FileCopyIcon />,
    elementId: 'clone-question-library-button'
  },
  {
    id: 'delete',
    tooltipLabel: 'Delete',
    icon: <DeleteIcon sx={{ color: '#E37D7A !important' }} />,
    elementId: 'delete-question-library-button'
  }
];

export const jobTemplatesActionsListItem: ActionListItem[] = [
  {
    id: 'edit',
    tooltipLabel: 'Edit',
    icon: <EditIcon />,
    elementId: 'edit-job-template-button',
    actionCall: (id: string) =>
      (window.location.href = BASE_URL + `/admin/job_templates/${id}/edit`)
  },
  {
    id: 'clone',
    tooltipLabel: 'Clone',
    icon: <FileCopyIcon />,
    elementId: 'clone-job-template-button'
  },
  {
    id: 'delete',
    tooltipLabel: 'Delete',
    icon: <DeleteIcon sx={{ color: '#E37D7A !important' }} />,
    elementId: 'delete-job-template-button'
  }
];

export const tagsActionsListItem: ActionListItem[] = [
  {
    id: 'edit',
    tooltipLabel: 'Edit',
    icon: <EditIcon />,
    elementId: 'edit-tag-button'
  },
  {
    id: 'delete',
    tooltipLabel: 'Trash',
    icon: <DeleteIcon sx={{ color: '#E37D7A !important' }} />,
    elementId: 'trash-tag-button'
  }
];
